import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { FetchUsersFailedPayload, FetchUsersPayload, FetchUsersSucceededPayload, UsersState } from './types';

export const initialState: UsersState = {
  users: [],
  isLoading: false,
  error: null,
  total: 0,
};

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    fetchUsersRequested(state, _action: PayloadAction<FetchUsersPayload>) {
      state.isLoading = true;
      state.error = null;
    },
    fetchUsersSucceeded(state, action: PayloadAction<FetchUsersSucceededPayload>) {
      state.users = action.payload.users;
      state.total = action.payload.total;
      state.isLoading = false;
      state.error = null;
    },
    fetchUsersFailed(state, action: PayloadAction<FetchUsersFailedPayload>) {
      state.isLoading = false;
      state.error = action.payload.message;
    },
    clearUsers(state) {
      state.users = [];
      state.total = 0;
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const { actions: usersActions } = usersSlice;

export const useUsersSlice = () => {
  return { actions: usersSlice.actions };
};

